// import { Button } from 'bootstrap'
import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
function PartnerContent() {
  return (
    <div className="partner-detail text-center">
      <Container fluid className="custom-container">
        <Row>
          <Col>
            <p>
              The only trusted exchange where users exchange shitcoins for
              rewards while allowing real companies and services to grow their
              customer base and communities.
            </p>
            <h1>BECOME A PARTNER</h1>
            <p>
              Schedule a call with us. We want to get to know you, answer any
              questions and verify that each service or project we offer to our
              users are legit. Here, we also discuss the technicals of getting
              your service listed. Listing is free of charge.
            </p>
            <Button className="talk-button" variant="none">
              <a
                href="https://shitcoinx.trycoffeechats.com/"
                className="text-white text-decoration-none"
                target="_blank"
              >
                Talk To Us
              </a>
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PartnerContent;
